<template>
  <div>
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.id"
      :model-value="true"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h6">
          {{ dialog.title }}
        </v-card-title>
        <v-card-text>
          <!-- NOTE: v-html is intentionally used here to allow HTML content in dialog messages. DO NOT CHANGE to text interpolation. -->
          <!-- eslint-disable-next-line vue/no-v-html, vue/html-self-closing -->
          <div v-html="dialog.message"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
           
            variant="text"
            @click="closeAlert(dialog.id)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
const alertDialog = useAlertDialog();

const dialogs = alertDialog.dialogs;

const closeAlert = (id: number) => {
  alertDialog.closeAlert(id);
};
</script>